export default "__VITE_ASSET__MHjphtG9__"